import { useState } from "react";
import { FaUsers } from "react-icons/fa";
import CohortsTable from "../../components/cohorts/CohortsTable";
import CreateCohortModal from "../../components/cohorts/CreateCohortModal";
import { useAuth } from "../../context/AuthContext";
import PageBanner from "../../components/common/PageBanner";

const CohortList = () => {
  const { currentUser, loading } = useAuth();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!currentUser) {
    return <div>Please log in to view reports</div>;
  }

  return (
    <div className="py-6 px-10">
      <PageBanner
        icon={<FaUsers />}
        title="Cohort Mode"
        description="Create a cohort session to track the competency mapping of a group of users. You can create up to 3 active cohorts at a time."
      >
        <button
          onClick={() => setIsCreateModalOpen(true)}
          className="bg-accent hover:bg-accentLight text-black font-semibold text-xs py-2 px-3 rounded my-2"
        >
          + Create New Cohort
        </button>
      </PageBanner>

      <CohortsTable userId={currentUser.id} />

      <CreateCohortModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
      />
    </div>
  );
};

export default CohortList;